package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.icons.Icon
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

enum class SidebarTab(val label: String, val icon: String, val route: String) {
    // News leads the nav (ad-traffic experiment 2026-09-15: content-first
    // entry point); Arena keeps the brand glyph in slot 2. Chat stays in the
    // DESKTOP SidebarNav only — the mobile BottomNavBar filters it out
    // (phones reach chat via the Arena top-bar icon).
    News("News", AppIcons.NewsHomeFilled, "/news"),
    Arena("Arena", AppIcons.ProPlayLogo, "/arena"),
    People("People", AppIcons.Radio, "/people"),
    // Same newspaper glyph the profile's "My feed" hub tab uses
    // (PlayerHubTab.Content).
    Feed("Feed", AppIcons.Globe, "/feed"),
    Chat("Chat", AppIcons.Chat, "/chat"),
    Profile("Profile", AppIcons.Profile, "/profile")
}

@Composable
fun SidebarNav(
    activeTab: SidebarTab? = null,
    onTabSelected: (SidebarTab) -> Unit = {}
) {
    val sportColors = LocalSportColors.current
    val t = LocalAppStrings.current
    fun tabLabel(tab: SidebarTab): String = when (tab) {
        SidebarTab.Arena -> t.navArena
        SidebarTab.News -> t.navNews
        SidebarTab.People -> t.navPeople
        SidebarTab.Feed -> t.navFeed
        SidebarTab.Chat -> t.navChat
        SidebarTab.Profile -> t.navProfile
    }

    Row(
        Modifier.styleModifier { property("gap", s(4)) },
        verticalAlignment = Alignment.CenterVertically
    ) {
        SidebarTab.entries.forEach { tab ->
            if (tab == activeTab) {
                NavAnchor(tab.route, onNavigate = { onTabSelected(tab) }) {
                Row(
                    Modifier
                        .sHeight(48)
                        .sBorderRadius(28)
                        .backgroundColor(sportColors.primary)
                        .sPadding(8, 18)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("box-shadow", "0px 4px 4px 0px rgba(0, 0, 0, 0.25)")
                            property("cursor", "pointer")
                            property("gap", s(8))
                        },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        src = tab.icon,
                        modifier = Modifier.styleModifier {
                            property("filter", sportColors.iconFilterOnPrimary)
                        }
                    )
                    SpanText(
                        tabLabel(tab),
                        modifier = Modifier
                            .bodyLMedium()
                            .color(sportColors.onPrimary)
                    )
                }
                }
            } else {
                NavAnchor(tab.route, onNavigate = { onTabSelected(tab) }) {
                Box(
                    Modifier
                        .sSize(48)
                        .sBorderRadius(100)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("border", "0.3px solid transparent")
                            property("background",
                                "${AppGradients.InteractiveSecondary} padding-box, " +
                                "linear-gradient(0deg, var(--arena-bg), var(--arena-bg)) padding-box, " +
                                "${AppGradients.ButtonBorderGradientPrimary} border-box")
                            property("cursor", "pointer")
                        },
                    contentAlignment = Alignment.Center
                ) {
                    // Inactive tabs render in the muted nav-blue (#B4CCF6).
                    // IconDefaultFilter starts with brightness(0), so it also
                    // normalizes the saturated #0061FF Pro Play ring and the
                    // stray white sub-path in the radio icon to the same tone.
                    Icon(
                        src = tab.icon,
                        modifier = Modifier.styleModifier {
                            property("filter", com.arena_web.ui.theme.ThemeVars.ICON_FILTER_V)
                        },
                    )
                }
                }
            }
        }
    }
}
